// engine
import { ArController, userDispatcher } from '@aceroll/core';

// hacksaw
import { responseService, uiService } from '@aceroll/platform-hacksaw';

// library
import { slotDispatcher } from '@aceroll/core/library';

export class FeatureSpinStop extends ArController {
    async onStart() {
        const serverEvent = responseService.getEvent();
        console.log('serverEvent', serverEvent);

        this.slotMachine = this.context.currentLayout.slotMachine;
        const { symbols, reelSet } = serverEvent.data;
        // const { gridWonSymbols } = responseService.currentResponse.parsed;

        slotDispatcher.updateSymbols(symbols, reelSet, []);
        await this.slotMachine.stop();

        uiService.offShowResult(userDispatcher.slamStop);
        this.stop();
    }
}